import React, { FC } from "react";
import { MatterTableWrapper } from "../../containers/matter-table";
import { Permission } from "../../hooks";
import pageStyles from "../page.module.css";
import { AccessControl } from "../../components/auth";
import { Link } from "react-router-dom";
import { Button } from "antd";

const { ["page-content"]: pageContentClassName } = pageStyles as any;

export const Matters: FC = () => {
  return (
    <div className={pageContentClassName}>
      <AccessControl permissions={Permission.READ_MATTER}>
        <div>
          <Button type="primary">
            <Link to="/create">Create Pricing Proposal</Link>
          </Button>
          <MatterTableWrapper />
        </div>
      </AccessControl>
    </div>
  );
};
